export const DEFAULT_LOCALE = "en";
export const SUPPORTED_LOCALES = ["en", "sk"];

const INTL_LOCALE_MAP = {
  en: "en-US",
  sk: "sk-SK",
};

export function resolveLocale(input) {
  const normalized = String(input ?? "")
    .trim()
    .toLowerCase();

  if (normalized.startsWith("sk")) {
    return "sk";
  }

  return DEFAULT_LOCALE;
}

export function getIntlLocale(locale) {
  return INTL_LOCALE_MAP[resolveLocale(locale)] ?? INTL_LOCALE_MAP.en;
}
